module.exports = __webpack_public_path__ + "img/post-boosting.3e4c0021.svg";